<template>
  <div>
    <app-cells>
      <app-input v-model="search" type="search" placeholder="Search tours to add" aria-label="Search tours to add" @input="onSearch" />
    </app-cells>
    <app-spinner v-if="loading && !loaded" />
    <app-cells v-else-if="failed">
      <span>Unable to load tours</span>
      <app-button @click.native="fetchItems">Retry</app-button>
    </app-cells>
    <template v-else>
      <funding-tours-table :items="items" :excluded="excluded" :coverage="!!relationship" :aria-busy="loading" selectable @select="add" @select-all="addAll" />
      <funding-pagination :page="page" :count="count" :length="items.length" @change="changePage" />
    </template>
  </div>
</template>

<script>
import { getTransferPricingFundingQueue } from '@/http'
import FundingToursTable from './ToursTable'
import FundingPagination from './Pagination'
import paginatedList from './paginatedList'
import { canSelect, directionParams, groupId, selectedRows } from './funding'

export default {
  name: 'FundingTourPicker',
  components: { FundingToursTable, FundingPagination },
  mixins: [paginatedList],
  props: {
    relationship: { type: String, default: '' },
    recipient: { type: String, default: '' },
    excluded: { type: Array, default: () => [] },
    disabled: Boolean,
    draftBatchId: { type: Number, default: null },
  },
  methods: {
    onItemsLoaded() { this.items = this.items.map(row => selectedRows([row])[0]) },
    requestItems(params) {
      return getTransferPricingFundingQueue({ ...params, ...directionParams(this.relationship, this.recipient), availability: 'available', draft_batch_id: this.draftBatchId || undefined })
    },
    add(row, checked) {
      if (checked && !this.disabled && !this.loading && !this.failed && canSelect(row) && !this.excluded.includes(groupId(row.group))) this.$emit('add', row)
    },
    addAll(checked) { this.items.forEach(row => this.add(row, checked)) },
  },
}
</script>
